import { render } from "./HeroiconsOutlinePencil.vue?vue&type=template&id=46d406ee"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePencil.vue"]])

export default __exports__